// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiRxGroup {
    static getAttributeTypeMap() {
        return PharmacyBiRxGroup.attributeTypeMap;
    }
}
PharmacyBiRxGroup.discriminator = undefined;
PharmacyBiRxGroup.additionalProperties = false;
PharmacyBiRxGroup.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiRxGroup.js.map